import designTokens from "../../../../../../packages/design-system/src/designTokens.ts";
import Text from "../../../../../../packages/design-system/src/Text";
import Spacings from "../../../../../../packages/design-system/src/Spacings/index.tsx";
import * as React from 'react';
export default {
  designTokens,
  Text,
  Spacings,
  React
};